import { trackEvent } from "@garantidos/utils/tracking"

const likert = (hashedCpf, eventLabel, experienceTrack) => {
  let ga4ExperienceTrack = ""

  switch (experienceTrack) {
    case "BAD":
      ga4ExperienceTrack = "ruim"
      break
    case "NOT_SATISFIED":
      ga4ExperienceTrack = "nao-gostei"
      break
    case "NOT_SURE":
      ga4ExperienceTrack = "neutro"
      break
    case "LIKED":
      ga4ExperienceTrack = "gostei"
      break
    case "LOVED":
      ga4ExperienceTrack = "adorei"
      break
  }

  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "score",
    detail: `envio-proposta-sucesso-${ga4ExperienceTrack}`
  }

  const ga = {
    label: `BTN:CGI:${eventLabel}`,
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

const alert = (hashedCpf, error) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "alert",
    description: "erro",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, "")
  }

  trackEvent({ ga4 })
}

export { likert, alert }
